export const serviceReduxConstants = {
  SET_SERVICES: 'SET_SERVICES',
  SET_SERVICE_CATEGORIES: 'SET_SERVICE_CATEGORIES',
};
